import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
type Quote = {
  id: string;
  quote: string;
  name?: string;
};
const QUOTES: Quote[] = [{
  id: 'raquel',
  quote: 'Jenna was such an amazing instructor, her energy was everything!',
  name: 'Raquel'
}, {
  id: 'outstanding',
  quote: 'An outstanding class, the best one I\u2019ve been to so far!'
}, {
  id: 'adrianne',
  quote: 'She is present, her instructions are clear and straightforward, making her a natural guide. What I loved most is that she sets an intention at the beginning of class and carries it through the entire flow, making each movement feel purposeful and achievable.',
  name: 'Adrianne'
}];
export function Testimonials() {
  const [active, setActive] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => {
      setActive(prev => (prev + 1) % QUOTES.length);
    }, 7000);
    return () => window.clearInterval(id);
  }, []);
  return <section className="w-full bg-cream py-24 md:py-36" data-id="element-161" data-mp="m4ro4cnjve6f">
      <div className="mx-auto max-w-3xl px-6 text-center md:px-10" data-id="element-162" data-mp="m6cio29v6x4a">
        <Reveal data-id="element-163" data-mp="78tt4xpd4fvs">
          <SectionLabel data-id="element-164" data-mp="79bn1nojyi0j">Words</SectionLabel>
        </Reveal>
        <Reveal delay={0.08} data-id="element-165" data-mp="c6bvg58vjwut">
          <h2 className="mt-7 font-display text-4xl font-light text-ink sm:text-5xl" data-id="element-166" data-mp="c7my21ql2ykc">
            From the community
          </h2>
        </Reveal>

        <div className="relative mt-14 min-h-[320px] sm:min-h-[260px]" data-id="element-167" data-mp="14vj1dpanroq3">
          <AnimatePresence mode="wait" data-id="element-168" data-mp="14xlre9bt9hut">
            <motion.blockquote key={active} initial={{
            opacity: 0,
            y: 14
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -14
          }} transition={{
            duration: 0.7,
            ease: [0.22, 1, 0.36, 1]
          }} className="absolute inset-x-0" data-id="element-169" data-mp="q7648ozu3zu0">
              <p className="font-display text-2xl font-light italic leading-[1.5] text-ink sm:text-[2rem]" data-id="element-170" data-mp="1nn22trp1auq0">
                &ldquo;{QUOTES[active].quote}&rdquo;
              </p>
              {QUOTES[active].name && <footer className="mt-8 text-[11px] font-light uppercase tracking-ultra text-clay" data-id="element-171" data-mp="1sjfq7jpg7sef">
                  {QUOTES[active].name}
                </footer>}
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-3" data-id="element-172" data-mp="1ejoejpmemo3l">
          {QUOTES.map((quote, i) => <button key={quote.id} type="button" onClick={() => setActive(i)} aria-label={quote.name ? `Show testimonial from ${quote.name}` : `Show testimonial ${i + 1}`} aria-current={i === active} className="group p-2" data-id="element-173" data-mp="19sogui5go201" data-mpi={i}>
              <span className={['block h-px w-8 transition-all duration-500', i === active ? 'bg-clay' : 'bg-clay/25 group-hover:bg-clay/60'].join(' ')} data-id="element-174" data-mp="vrvkdrvlmwua" />
            </button>)}
        </div>
      </div>
    </section>;
}